import { render } from "./Objective.vue?vue&type=template&id=cb9957f8&scoped=true"
import script from "./Objective.vue?vue&type=script&lang=js"
export * from "./Objective.vue?vue&type=script&lang=js"

import "./Objective.vue?vue&type=style&index=0&id=cb9957f8&lang=scss&scoped=true"
import "./Objective.vue?vue&type=style&index=1&id=cb9957f8&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb9957f8"]])

export default __exports__